import { IEnvironment } from '../models/environment.model';

export class EnvironmentLoader {
  private static env: IEnvironment;

  public static get environment(): IEnvironment {
    return EnvironmentLoader.env;
  }

  public static async loadEnvironment(): Promise<void> {
    const response = await fetch('/valutrax/assets/config.release.json');
    try {
      EnvironmentLoader.env = await response.json();
    } catch (e) {
      console.log('Could not load config!');
    }
  }
}
